import Card from '@mui/material/Card';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { LocaleContext } from '../../../contexts/language';
import { FormattedNumber } from 'react-intl';
import React from 'react';
import { IntlProvider, FormattedMessage } from 'react-intl';
import { PropTypes } from 'prop-types';
import CardContent from '@mui/material/CardContent';
import ar from './ar.json';
import en from './en.json';

const languages = {
  ar,
  en
};


export const OfferPriceBreakdown = ({
  currency,
  monthlyAmount,
  purchaseAmount,
  onSelect,

}) => {

  const localeConfig = React.useContext(LocaleContext);

  return (
    <IntlProvider locale={localeConfig?.lang || 'en'} messages={languages[localeConfig?.lang] || languages.en}>

      <Card sx={{ mt:3 }}>
        <CardContent>
          <Stack spacing={2}>
            {monthlyAmount ? (
              <Stack direction={'row'} sx={{ justifyContent: 'space-between' }}>
                <Typography><FormattedMessage id={'paymentTerms.estimatedMonthlyPayment'}
                  defaultMessage={'Estimated Monthly Payment'} /></Typography>
                <Typography
                  sx={{ fontWeight: 600 }}
                >
                  <FormattedNumber value={monthlyAmount}
                    currency={currency}
                    /* eslint-disable-next-line react/style-prop-object */
                    style={'currency'}
                    maximumFractionDigits={0} minimumFractionDigits={0}
                  />
                </Typography>
              </Stack>
            ) : null}

            {purchaseAmount ? (
              <Stack direction={'row'} sx={{ justifyContent: 'space-between' }}>
                <Typography><FormattedMessage id={'paymentTerms.totalAmount'} defaultMessage={'Total Amount'} /></Typography>
                <Typography
                  sx={{ fontWeight: 600 }}
                >
                  <FormattedNumber value={purchaseAmount}
                    currency={currency}
                    /* eslint-disable-next-line react/style-prop-object */
                    style={'currency'}
                    maximumFractionDigits={0} minimumFractionDigits={0}
                  />
                </Typography>
              </Stack>

            ) : null}

            <Stack direction={'row-reverse'}>
              <Button
                variant={'contained'}
                color={'primary'}
                onClick={onSelect}
                sx={{ width: { xs: '100%', md: 'auto' } }}
              >
                <FormattedMessage id={'paymentTerms.contactDealer'} defaultMessage={'Contact Dealer'} />

              </Button>
            </Stack>


          </Stack>
        </CardContent>
      </Card>

    </IntlProvider>
  );
};
export default OfferPriceBreakdown;
OfferPriceBreakdown.propTypes = {
  currency: PropTypes.string.isRequired,
  selectedExtras: PropTypes.number.isRequired,
  monthlyAmount: PropTypes.number.isRequired,
  purchaseAmount: PropTypes.number.isRequired,
  onSelect: PropTypes.func.isRequired
};
